import { API_CONFIG } from '../../shared/api/config';
import composeRequest from '../../shared/api/core';
import { ExpiringStockTrackerCreatePayload } from '../models';

const BASE_URL = API_CONFIG.API_BASE_PATH;

export const API_URLS = {
    expiringStockTrackersUrl: BASE_URL + 'korona/expiring-stock/',
    expiringStockPromoTemplatesUrl: BASE_URL + 'korona/expiring-stock/templates/',
    expiringStockKoronaPromotionsUrl: BASE_URL + 'korona/expiring-stock/korona-promotions',
    locationsUrl: BASE_URL + 'core/locations/',
};

export const getLocations = (businessId: number | string) => {
    const URL = `${API_URLS.locationsUrl}?business_id=${businessId}`;
    return composeRequest(URL, 'GET', null);
};

export const getExpiringStockTrackers = (
    businessId: number | string,
    page: number,
    pageSize: number,
    status?: string | null,
    orderBy?: string | null,
    search?: string | null
) => {
    let URL = `${API_URLS.expiringStockTrackersUrl}?business_ids=${businessId}&page=${page}&page_size=${pageSize}`;
    if (status) {
        URL += `&status=${status}`;
    }
    if (orderBy) {
        URL += `&orderBy=${orderBy}`;
    }
    if (search) {
        URL += `&search=${encodeURIComponent(search)}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const createExpiringStockTracker = (data: ExpiringStockTrackerCreatePayload) => {
    return composeRequest(API_URLS.expiringStockTrackersUrl, 'POST', JSON.stringify(data), 'application/json');
};

export const deactivateExpiringStockTracker = (id: number) => {
    const URL = `${API_URLS.expiringStockTrackersUrl}${id}/deactivate/`;
    return composeRequest(URL, 'POST', null);
};

/** Re-attempt Korona promo deactivation for an already-deactivated tracker (orphan cleanup). */
export const syncKoronaDeactivateExpiringStockTracker = (id: number) => {
    const URL = `${API_URLS.expiringStockTrackersUrl}${id}/sync-korona-deactivate/`;
    return composeRequest(URL, 'POST', null);
};

export const archiveExpiringStockTracker = (id: number) => {
    const URL = `${API_URLS.expiringStockTrackersUrl}${id}/archive/`;
    return composeRequest(URL, 'POST', null);
};

export const getExpiringStockPromoTemplates = (businessId: number | string) => {
    const URL = `${API_URLS.expiringStockPromoTemplatesUrl}?business_ids=${businessId}&page=1&page_size=200`;
    return composeRequest(URL, 'GET', null);
};

export const createExpiringStockPromoTemplate = (data: any) => {
    return composeRequest(
        API_URLS.expiringStockPromoTemplatesUrl,
        'POST',
        JSON.stringify(data),
        'application/json'
    );
};

export const updateExpiringStockPromoTemplate = (id: number, data: any) => {
    const URL = `${API_URLS.expiringStockPromoTemplatesUrl}${id}/`;
    return composeRequest(URL, 'PATCH', JSON.stringify(data), 'application/json');
};

export const deleteExpiringStockPromoTemplate = (id: number) => {
    const URL = `${API_URLS.expiringStockPromoTemplatesUrl}${id}/`;
    return composeRequest(URL, 'DELETE', null);
};

export const previewExpiringStockPromoTemplate = (
    id: number,
    data: { product_id: string; location_id?: number | null; product_expiry_date?: string | null }
) => {
    const URL = `${API_URLS.expiringStockPromoTemplatesUrl}${id}/preview/`;
    return composeRequest(URL, 'POST', JSON.stringify(data), 'application/json');
};

export const getActiveKoronaPromotions = (businessId: number | string) => {
    const URL = `${API_URLS.expiringStockKoronaPromotionsUrl}?business_ids=${businessId}`;
    return composeRequest(URL, 'GET', null);
};
